export {
  DemographicsAgeChart,
  DemographicsGenderChart,
  DemographicsIncomeChart,
} from './Demographics';
